module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isHorizontal) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": _vm.vaId
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isDisabled,
      "multiple": _vm.isMultiple
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "data": item
      }
    }, [_vm._v("\n        " + _vm._s(item) + "\n      ")])
  }), 0)])]) : _c('select', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isDisabled,
      "multiple": _vm.isMultiple
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "data": item
      }
    }, [_vm._v("\n    " + _vm._s(item) + "\n  ")])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c03d0a6e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VASelect.vue
// module id = 743
// module chunks = 1